<template>
  <div>
    <section-title color="blue-4">
      Eyes
    </section-title>
    <div class="left-eye">
      <label>{{ leftEyeState.name[language] }}</label>
      <radio-buttons
        data-testid="left-eye-radio-buttons"
        :options="getRadioOptions(leftEyeState)"
        :value="state.left.state.options.value"
        :disabled="readonly"
        :aria-label="leftEyeState.name[language]"
        active-color="blue-4"
        inactive-color="white"
        :bordered="true"
        @input="value => updateLeftEyeState(value)"
      />
      <md-checkbox
        class="md-primary"
        :value="state.left.nonreactive"
        aria-label="Left Eye Nonreactive"
        data-testid="left-eye-nonreactive-checkbox"
        @change="(value) => toggleLeftNonreactive(value)"
      >
        Nonreactive
      </md-checkbox>
      <label>{{ rightEyeState.name[language] }}</label>
      <radio-buttons
        data-testid="right-eye-radio-buttons"
        :options="getRadioOptions(rightEyeState)"
        :value="state.right.state.options.value"
        :disabled="readonly"
        :aria-label="rightEyeState.name[language]"
        active-color="blue-4"
        inactive-color="white"
        :bordered="true"
        @input="value => updateRightEyeState(value)"
      />
      <md-checkbox
        class="md-primary"
        :value="state.right.nonreactive"
        aria-label="Right Eye Nonreactive"
        data-testid="right-eye-nonreactive-checkbox"
        @change="(value) => toggleRightNonreactive(value)"
      >
        Nonreactive
      </md-checkbox>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

import states from '~lib/common/config/states';
import RadioButtons from '~lib/common/components/RadioButtons';
import SectionTitle from '../../common/SectionTitle.vue';

export default {
  name: 'case-eyes',
  components: {
    SectionTitle,
    RadioButtons
  },
  props: {
    caseConf: {
      type: Object,
      required: true,
    },
    isNewCase: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      language: 'en',
      state: {
        left: {
          nonreactive: false,
          state: {
            id: 'leftEye',
            options: { value: 'NORMAL' }
          },
        },
        right: {
          nonreactive: false,
          state: {
            id: 'rightEye',
            options: { value: 'NORMAL' }
          },
        }
      }
    };
  },
  computed: {
    leftEyeState() {
      return states.find(state => state.id === 'leftEye');
    },
    rightEyeState() {
      return states.find(state => state.id === 'rightEye');
    }
  },
  mounted() {
    this.state.left.nonreactive = get(this.caseConf.initialConditions, 'leftEye.nonreactive', false);
    this.state.right.nonreactive = get(this.caseConf.initialConditions, 'rightEye.nonreactive', false);
    const leftState = this.caseConf._initialStates.find(edge => edge.id === 'leftEye');
    if (leftState) {
      this.state.left.state = leftState;
    }
    const rightState = this.caseConf._initialStates.find(edge => edge.id === 'rightEye');
    if (rightState) {
      this.state.right.state = rightState;
    }
  },
  methods: {
    getRadioOptions(state) {
      return state.possibleValues.map(val => ({
        value: val.key,
        label: val.label[this.language],
      }));
    },
    updateLeftEyeState(value) {
      this.state.left.state.options.value = value;
      this.update({
        _initialStates: [ this.state.left.state ]
      })
    },
    toggleLeftNonreactive(value) {
      this.state.left.nonreactive = value;
      this.update({
        initialConditions: {
          leftEye: {
            nonreactive: value
          }
        }
      })
    },
    updateRightEyeState(value) {
      this.state.right.state.options.value = value;
      this.update({
        _initialStates: [ this.state.right.state ]
      })
    },
    toggleRightNonreactive(value) {
      this.state.right.nonreactive = value;
      this.update({
        initialConditions: {
          rightEye: {
            nonreactive: value
          }
        }
      })
    },
    update(...args) {
      this.$emit('update', ...args);
    },
  },
};
</script>

<style scoped>
.section-title {
  margin-bottom: 16px;
}
.left-eye, .right-eye {
  display: grid;
  align-items: center;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(2, auto);
  column-gap: 16px;
}
</style>
